import * as Yup from "yup";
export const RouteSecStopvalidation = Yup.object().shape({
  ContactName: Yup.string().required("Contact name is required"),
  phoneNumber: Yup.number().required("Phone Number is required"),
  EmailAddress: Yup.string().email().required("Email is required"),
  SelectType: Yup.string().required("Type is required"),
  Location: Yup.string().required("Location is required"),
  Notes: Yup.string().required("Notes is required"),
});
export const RouteStopOnevalidation = Yup.object().shape({
  ContactName: Yup.string().required("Contact name is required"),
  phoneNumber: Yup.number().required("Phone Number is required"),
  EmailAddress: Yup.string().email().required("Email is required"),
  SelectType: Yup.string().required("Type is required"),
  Location: Yup.string().required("Location is required"),
  Notes: Yup.string().required("Notes is required"),
});
export const RouteOrderDetailsvalidation = Yup.object().shape({
  CargoName: Yup.string().required("Cargo name is required"),
  Length: Yup.number().required("length is required"),
  WidthLbs: Yup.number().required("Width is required"),
  WidthIn: Yup.number().required("Width is required"),
  HeightIn: Yup.number().required("Height is required"),

  CargoImages: Yup.array().min(1, "Please select at least one image"),
  // .of(
  //   Yup.mixed().test(
  //     "fileFormat",
  //     "Invalid file format",
  //     (value) => value && value.type && value.type.includes("image/")
  //   )
  // ),
  DateTime: Yup.date().required("DateTime is required"),
  CargoDescription: Yup.string().required("Cargo description  is required"),
});
